import { render } from "./SqueezeBreadcrumb.vue?vue&type=template&id=3104b87b&scoped=true&ts=true"
import script from "./SqueezeBreadcrumb.vue?vue&type=script&lang=ts"
export * from "./SqueezeBreadcrumb.vue?vue&type=script&lang=ts"

import "./SqueezeBreadcrumb.vue?vue&type=style&index=0&id=3104b87b&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3104b87b"]])

export default __exports__